import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd1ed490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wechatContacts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "频道", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "群组", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "用户", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, computed, onMounted } from "vue";
import { tgAPI } from '@/api/telegram';
import { TgActions, TgGetters, TgMutations } from "@/store/modules/telegram";
import TgSessionCard from "@/components/telegram/TgSessionCard.vue";


import { defineComponent } from "vue";
import { TgConversation } from "@/store/modules/telegram/types";

const __default__ = defineComponent({
    name: "TgContactWindow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const activeName = ref<string>('channel')

const route = useRoute();
const store = useStore();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const tgIdCom = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeId}`];
});
const channelList = computed(() => {
    return store.getters[`telegram/${TgGetters.getChannelList}`];
});
const chatList = computed(() => {
    return store.getters[`telegram/${TgGetters.getChatList}`];
});
const userList = computed(() => {
    return store.getters[`telegram/${TgGetters.getUserList}`];
});
const selectedConv = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectedConv}`];
});
const isChannelLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsChannelLoading}`];
});
const isChatLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsChatLoading}`];
});
const isUserLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsUserLoading}`];
});
const isChannelAllLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getChannelAllLoaded}`];
});
const isChatAllLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getChatAllLoaded}`];
});
const isUseAllLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getUserAllLoaded}`];
});
const isConvSelected = (convId: number) => {
    if (selectedConv.value) {
        return selectedConv.value.Id === convId;
    } else {
        return false
    }
}

const handleClick = (contact: any, type: string) => {
    store.commit(`telegram/${TgMutations.setSelectedConv}`, contact);
    store.commit(`telegram/${TgMutations.setSelectedConvType}`, type);

}

const asyncGetChannelList = () => {
    const projId = projectId.value;
    const uid = targetId.value;
    const tgId = tgIdCom.value;
    const isAppend = true;
    try {
        store.dispatch(`telegram/${TgActions.asyncGetChannelListByUidAndTgId}`, { projId, uid, tgId, isAppend });
    } catch (err) {
        console.log(err);
    }
}
const asyncGetChatList = () => {
    const projId = projectId.value;
    const uid = targetId.value;
    const tgId = tgIdCom.value;
    const isAppend = true;
    try {
        store.dispatch(`telegram/${TgActions.asyncGetChatListByUidAndTgId}`, { projId, uid, tgId, isAppend });
    } catch (err) {
        console.log(err);
    }
}
const asyncGetUserList = () => {
    const projId = projectId.value;
    const uid = targetId.value;
    const tgId = tgIdCom.value;
    const isAppend = true;
    try {
        store.dispatch(`telegram/${TgActions.asyncGetUserListByUidAndTgId}`, { projId, uid, tgId, isAppend });
    } catch (err) {
        console.log(err);
    }
}
const loadTgContact = () => {
    if (activeName.value === 'channel') {
        if (!isChannelAllLoaded.value && !isChannelLoading.value)
            asyncGetChannelList()
    } else if (activeName.value === 'chat') {
        if (!isChatAllLoaded.value && !isChatLoading.value)
            asyncGetChatList()
    } else if (activeName.value === 'user') {
        if (!isUserLoading.value && !isUseAllLoaded.value)
            asyncGetUserList()
    }
}

const getConvName = (conv: TgConversation) => {
    if (conv.Type === 'user') {
        return conv.Title === '' ? conv.Name : `${conv.Name} + (${conv.Title})`
    } else {
        return conv.Title === '' ? conv.Name : conv.Title

    }
}

const asyncGetTgIdList = async (projid: string, uid: string) => {
    store.dispatch(`telegram/${TgActions.asyncGetMeId}`, { projid, uid });
}


onMounted(() => {
    // activeName.value === undefined ? activeName.value = ['contact'] : activeName.value.push('contact')

    let projid = projectId.value
    let uid = targetId.value
    try {
        asyncGetTgIdList(projid, uid)
        asyncGetChannelList()
        asyncGetChatList()
        asyncGetUserList()
    } catch (err) {
        console.log(err);
    }

});



return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createBlock(_component_el_collapse, {
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
    accordion: ""
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_collapse_item, { name: "channel" }, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(channelList), (channel) => {
              return (_openBlock(), _createElementBlock("div", {
                key: channel.Title
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isConvSelected(channel.Id) }),
                  onClick: ($event: any) => (handleClick(channel, 'channel'))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(TgSessionCard, {
                      msgSender: channel.Title === '' ? channel.Name : channel.Title,
                      msgContent: '[消息内容]',
                      target: ''
                    }, null, 8, ["msgSender"])
                  ])
                ], 10, _hoisted_3)
              ]))
            }), 128)),
            (_unref(isChannelLoading))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "加载中......"))
              : _createCommentVNode("", true),
            (_unref(isChannelAllLoaded))
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "------已加载全部-------"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_collapse_item, { name: "chat" }, {
          title: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatList), (chat) => {
              return (_openBlock(), _createElementBlock("div", {
                key: chat.Title
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isConvSelected(chat.Id) }),
                  onClick: ($event: any) => (handleClick(chat, 'chat'))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(TgSessionCard, {
                      msgSender: chat.Title === '' ? chat.Name : chat.Title,
                      msgContent: '[消息内容]',
                      target: ''
                    }, null, 8, ["msgSender"])
                  ])
                ], 10, _hoisted_7)
              ]))
            }), 128)),
            (_unref(isChatLoading))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "加载中......"))
              : _createCommentVNode("", true),
            (_unref(isChatAllLoaded))
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "------已加载全部-------"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_collapse_item, { name: "user" }, {
          title: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.Username
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isConvSelected(user.Id) }),
                  onClick: ($event: any) => (handleClick(user, 'user'))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(TgSessionCard, {
                      msgSender: user.Username === '' ? user.Name : user.Name + '（' + user.Username + '）',
                      msgContent: '[消息内容]',
                      target: ''
                    }, null, 8, ["msgSender"])
                  ])
                ], 10, _hoisted_11)
              ]))
            }), 128)),
            (_unref(isUserLoading))
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, "加载中......"))
              : _createCommentVNode("", true),
            (_unref(isUseAllLoaded))
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "------已加载全部-------"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])), [
        [_directive_infinite_scroll, loadTgContact]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})